export const cabinets = {
  extends: 'Page',
  flow: 'x',
  minHeight: '100vh',
  background: 'ink',
  color: 'inkText',

  TabInit: { display: 'none', show: (() => { let d = false; return (el, s) => { if (!d) { d = true; Promise.resolve().then(() => s.root.update({ activeTab: 'cabinets' })) } return false } })() },

  NavSidebar: {},

  MainContent: {
    flow: 'y',
    flex: '1',
    overflow: 'auto',

    TopBar: {},

    ContentArea: {
      flow: 'y',
      gap: 'B',
      padding: 'B',
      flex: '1',
      '@mobileL': { padding: 'A' },

      // ─── PAGE HEADER ─────────────────────────────
      PageHeader: {
        flow: 'x',
        gap: 'A',
        align: 'center space-between',
        flexWrap: 'wrap',
        '@mobileL': { flow: 'y', gap: 'Z' },

        LeftSection: {
          flow: 'y', gap: 'X',
          Title: { text: '{{ cabinetSchedule | polyglot }}', fontSize: 'C', fontWeight: '700', color: 'inkText' },
          Subtitle: { text: '{{ cabinetScheduleDesc | polyglot }}', fontSize: 'Z', color: 'inkMuted' }
        },

        RightControls: {
          flow: 'x', gap: 'Z', align: 'center flex-end',

          DateNav: {
            flow: 'x', gap: 'Y', align: 'center center',
            PrevBtn: { text: '\u2190', fontSize: 'Z', fontWeight: '600', padding: 'Y Z', round: 'Y', background: 'inkMid', border: '1px solid inkBorder', color: 'inkText', cursor: 'pointer' },
            TodayBtn: { text: '{{ today | polyglot }}', fontSize: 'Y', fontWeight: '600', padding: 'Y Z', round: 'Y', background: 'inkMid', border: '1px solid inkBorder', color: 'teal', cursor: 'pointer' },
            NextBtn: { text: '\u2192', fontSize: 'Z', fontWeight: '600', padding: 'Y Z', round: 'Y', background: 'inkMid', border: '1px solid inkBorder', color: 'inkText', cursor: 'pointer' },
            DateLabel: { text: 'Mar 19, 2026', fontSize: 'Z', fontWeight: '600', color: 'inkText', marginLeft: 'Y' }
          }
        }
      },

      // ─── STATUS LEGEND ────────────────────────────
      StatusLegend: {
        flow: 'x', gap: 'A', marginBottom: 'Y', flexWrap: 'wrap',
        Leg1: { flow: 'x', gap: 'Y', align: 'center center', Dot: { width: 'Z', height: 'Z', round: 'Z', background: 'teal' }, Label: { text: '{{ available | polyglot }}', fontSize: 'Y', color: 'inkMuted' } },
        Leg2: { flow: 'x', gap: 'Y', align: 'center center', Dot: { width: 'Z', height: 'Z', round: 'Z', background: 'blue' }, Label: { text: '{{ occupied | polyglot }}', fontSize: 'Y', color: 'inkMuted' } },
        Leg3: { flow: 'x', gap: 'Y', align: 'center center', Dot: { width: 'Z', height: 'Z', round: 'Z', background: 'amber' }, Label: { text: '{{ cleaning | polyglot }}', fontSize: 'Y', color: 'inkMuted' } },
        Leg4: { flow: 'x', gap: 'Y', align: 'center center', Dot: { width: 'Z', height: 'Z', round: 'Z', background: 'red' }, Label: { text: '{{ maintenance | polyglot }}', fontSize: 'Y', color: 'inkMuted' } }
      },

      // ─── CABINET COLUMNS ──────────────────────────
      CabinetGrid: {
        flow: 'x',
        gap: 'A',
        overflow: 'auto',
        padding: 'Y 0',
        flex: '1',

        // Cabinet 1 — mostly occupied
        Cabinet1: {
          extends: 'CabinetColumn',
          state: { cabinetName: 'Cabinet 1', cabinetStatus: 'in-use' },
          Slots: {
            S0900: { state: { time: '09:00', status: 'occupied', doctor: 'Dr. Kvaratskhelia', patient: 'T. Kapanadze', procedure: '{{ crownPrep | polyglot }}', cabinetName: 'Cabinet 1' } },
            S0930: { state: { time: '09:30', status: 'occupied', doctor: 'Dr. Kvaratskhelia', patient: 'T. Kapanadze', procedure: '{{ crownPrep | polyglot }}', cabinetName: 'Cabinet 1' } },
            S1000: { state: { time: '10:00', status: 'available', cabinetName: 'Cabinet 1' } },
            S1030: { state: { time: '10:30', status: 'occupied', doctor: 'Dr. Kvaratskhelia', patient: 'M. Tsiklauri', procedure: '{{ compositeF | polyglot }}', cabinetName: 'Cabinet 1' } },
            S1100: { state: { time: '11:00', status: 'occupied', doctor: 'Dr. Kvaratskhelia', patient: 'M. Tsiklauri', procedure: '{{ compositeF | polyglot }}', cabinetName: 'Cabinet 1' } },
            S1130: { state: { time: '11:30', status: 'cleaning', cabinetName: 'Cabinet 1' } },
            S1200: { state: { time: '12:00', status: 'available', cabinetName: 'Cabinet 1' } },
            S1230: { state: { time: '12:30', status: 'available', cabinetName: 'Cabinet 1' } },
            S1300: { state: { time: '13:00', status: 'occupied', doctor: 'Dr. Kvaratskhelia', patient: 'R. Kharazishvili', procedure: '{{ bridgePrep | polyglot }}', cabinetName: 'Cabinet 1' } },
            S1330: { state: { time: '13:30', status: 'occupied', doctor: 'Dr. Kvaratskhelia', patient: 'R. Kharazishvili', procedure: '{{ bridgePrep | polyglot }}', cabinetName: 'Cabinet 1' } },
            S1400: { state: { time: '14:00', status: 'occupied', doctor: 'Dr. Kvaratskhelia', patient: 'R. Kharazishvili', procedure: '{{ bridgePrep | polyglot }}', cabinetName: 'Cabinet 1' } },
            S1430: { state: { time: '14:30', status: 'cleaning', cabinetName: 'Cabinet 1' } },
            S1500: { state: { time: '15:00', status: 'occupied', doctor: 'Dr. Kvaratskhelia', patient: 'A. Javakhishvili', procedure: '{{ rootCanal | polyglot }}', cabinetName: 'Cabinet 1' } },
            S1530: { state: { time: '15:30', status: 'occupied', doctor: 'Dr. Kvaratskhelia', patient: 'A. Javakhishvili', procedure: '{{ rootCanal | polyglot }}', cabinetName: 'Cabinet 1' } },
            S1600: { state: { time: '16:00', status: 'available', cabinetName: 'Cabinet 1' } },
            S1630: { state: { time: '16:30', status: 'available', cabinetName: 'Cabinet 1' } },
            S1700: { state: { time: '17:00', status: 'available', cabinetName: 'Cabinet 1' } },
            S1730: { state: { time: '17:30', status: 'available', cabinetName: 'Cabinet 1' } }
          }
        },

        // Cabinet 2 — mixed schedule
        Cabinet2: {
          extends: 'CabinetColumn',
          state: { cabinetName: 'Cabinet 2', cabinetStatus: 'available' },
          Slots: {
            S0900: { state: { time: '09:00', status: 'occupied', doctor: 'Dr. Beridze', patient: 'D. Gelashvili', procedure: '{{ srpQuad | polyglot }}', cabinetName: 'Cabinet 2' } },
            S0930: { state: { time: '09:30', status: 'occupied', doctor: 'Dr. Beridze', patient: 'D. Gelashvili', procedure: '{{ srpQuad | polyglot }}', cabinetName: 'Cabinet 2' } },
            S1000: { state: { time: '10:00', status: 'occupied', doctor: 'Dr. Beridze', patient: 'D. Gelashvili', procedure: '{{ srpQuad | polyglot }}', cabinetName: 'Cabinet 2' } },
            S1030: { state: { time: '10:30', status: 'cleaning', cabinetName: 'Cabinet 2' } },
            S1100: { state: { time: '11:00', status: 'available', cabinetName: 'Cabinet 2' } },
            S1130: { state: { time: '11:30', status: 'available', cabinetName: 'Cabinet 2' } },
            S1200: { state: { time: '12:00', status: 'available', cabinetName: 'Cabinet 2' } },
            S1230: { state: { time: '12:30', status: 'available', cabinetName: 'Cabinet 2' } },
            S1300: { state: { time: '13:00', status: 'occupied', doctor: 'Dr. Beridze', patient: 'K. Gabrichidze', procedure: '{{ veneerPrep | polyglot }}', cabinetName: 'Cabinet 2' } },
            S1330: { state: { time: '13:30', status: 'occupied', doctor: 'Dr. Beridze', patient: 'K. Gabrichidze', procedure: '{{ veneerPrep | polyglot }}', cabinetName: 'Cabinet 2' } },
            S1400: { state: { time: '14:00', status: 'cleaning', cabinetName: 'Cabinet 2' } },
            S1430: { state: { time: '14:30', status: 'occupied', doctor: 'Dr. Beridze', patient: 'Z. Dolidze', procedure: '{{ implantPlace | polyglot }}', cabinetName: 'Cabinet 2' } },
            S1500: { state: { time: '15:00', status: 'occupied', doctor: 'Dr. Beridze', patient: 'Z. Dolidze', procedure: '{{ implantPlace | polyglot }}', cabinetName: 'Cabinet 2' } },
            S1530: { state: { time: '15:30', status: 'occupied', doctor: 'Dr. Beridze', patient: 'Z. Dolidze', procedure: '{{ implantPlace | polyglot }}', cabinetName: 'Cabinet 2' } },
            S1600: { state: { time: '16:00', status: 'available', cabinetName: 'Cabinet 2' } },
            S1630: { state: { time: '16:30', status: 'occupied', doctor: 'Dr. Beridze', patient: 'E. Tsereteli', procedure: '{{ examConsult | polyglot }}', cabinetName: 'Cabinet 2' } },
            S1700: { state: { time: '17:00', status: 'available', cabinetName: 'Cabinet 2' } },
            S1730: { state: { time: '17:30', status: 'available', cabinetName: 'Cabinet 2' } }
          }
        },

        // Cabinet 3 — hygienist room
        Cabinet3: {
          extends: 'CabinetColumn',
          state: { cabinetName: 'Cabinet 3', cabinetStatus: 'in-use' },
          Slots: {
            S0900: { state: { time: '09:00', status: 'occupied', doctor: 'Hyg. Nino', patient: 'I. Diasamidze', procedure: '{{ prophyClean | polyglot }}', cabinetName: 'Cabinet 3' } },
            S0930: { state: { time: '09:30', status: 'cleaning', cabinetName: 'Cabinet 3' } },
            S1000: { state: { time: '10:00', status: 'occupied', doctor: 'Hyg. Nino', patient: 'T. Lomidze', procedure: '{{ perioMaint | polyglot }}', cabinetName: 'Cabinet 3' } },
            S1030: { state: { time: '10:30', status: 'occupied', doctor: 'Hyg. Nino', patient: 'T. Lomidze', procedure: '{{ perioMaint | polyglot }}', cabinetName: 'Cabinet 3' } },
            S1100: { state: { time: '11:00', status: 'cleaning', cabinetName: 'Cabinet 3' } },
            S1130: { state: { time: '11:30', status: 'occupied', doctor: 'Hyg. Nino', patient: 'N. Gogiberidze', procedure: '{{ prophyClean | polyglot }}', cabinetName: 'Cabinet 3' } },
            S1200: { state: { time: '12:00', status: 'available', cabinetName: 'Cabinet 3' } },
            S1230: { state: { time: '12:30', status: 'available', cabinetName: 'Cabinet 3' } },
            S1300: { state: { time: '13:00', status: 'occupied', doctor: 'Hyg. Nino', patient: 'S. Meladze', procedure: '{{ fluorideTx | polyglot }}', cabinetName: 'Cabinet 3' } },
            S1330: { state: { time: '13:30', status: 'cleaning', cabinetName: 'Cabinet 3' } },
            S1400: { state: { time: '14:00', status: 'occupied', doctor: 'Hyg. Nino', patient: 'L. Mchedlishvili', procedure: '{{ sealants | polyglot }}', cabinetName: 'Cabinet 3' } },
            S1430: { state: { time: '14:30', status: 'occupied', doctor: 'Hyg. Nino', patient: 'L. Mchedlishvili', procedure: '{{ sealants | polyglot }}', cabinetName: 'Cabinet 3' } },
            S1500: { state: { time: '15:00', status: 'available', cabinetName: 'Cabinet 3' } },
            S1530: { state: { time: '15:30', status: 'occupied', doctor: 'Hyg. Nino', patient: 'B. Shengelia', procedure: '{{ prophyClean | polyglot }}', cabinetName: 'Cabinet 3' } },
            S1600: { state: { time: '16:00', status: 'cleaning', cabinetName: 'Cabinet 3' } },
            S1630: { state: { time: '16:30', status: 'available', cabinetName: 'Cabinet 3' } },
            S1700: { state: { time: '17:00', status: 'available', cabinetName: 'Cabinet 3' } },
            S1730: { state: { time: '17:30', status: 'available', cabinetName: 'Cabinet 3' } }
          }
        },

        // Cabinet 4 — under maintenance in AM
        Cabinet4: {
          extends: 'CabinetColumn',
          state: { cabinetName: 'Cabinet 4', cabinetStatus: 'maintenance' },
          Slots: {
            S0900: { state: { time: '09:00', status: 'maintenance', cabinetName: 'Cabinet 4' } },
            S0930: { state: { time: '09:30', status: 'maintenance', cabinetName: 'Cabinet 4' } },
            S1000: { state: { time: '10:00', status: 'maintenance', cabinetName: 'Cabinet 4' } },
            S1030: { state: { time: '10:30', status: 'maintenance', cabinetName: 'Cabinet 4' } },
            S1100: { state: { time: '11:00', status: 'maintenance', cabinetName: 'Cabinet 4' } },
            S1130: { state: { time: '11:30', status: 'maintenance', cabinetName: 'Cabinet 4' } },
            S1200: { state: { time: '12:00', status: 'available', cabinetName: 'Cabinet 4' } },
            S1230: { state: { time: '12:30', status: 'available', cabinetName: 'Cabinet 4' } },
            S1300: { state: { time: '13:00', status: 'occupied', doctor: 'Dr. Kvaratskhelia', patient: 'V. Papunashvili', procedure: '{{ extraction | polyglot }}', cabinetName: 'Cabinet 4' } },
            S1330: { state: { time: '13:30', status: 'cleaning', cabinetName: 'Cabinet 4' } },
            S1400: { state: { time: '14:00', status: 'occupied', doctor: 'Dr. Beridze', patient: 'G. Beridze', procedure: '{{ whitening | polyglot }}', cabinetName: 'Cabinet 4' } },
            S1430: { state: { time: '14:30', status: 'occupied', doctor: 'Dr. Beridze', patient: 'G. Beridze', procedure: '{{ whitening | polyglot }}', cabinetName: 'Cabinet 4' } },
            S1500: { state: { time: '15:00', status: 'cleaning', cabinetName: 'Cabinet 4' } },
            S1530: { state: { time: '15:30', status: 'available', cabinetName: 'Cabinet 4' } },
            S1600: { state: { time: '16:00', status: 'available', cabinetName: 'Cabinet 4' } },
            S1630: { state: { time: '16:30', status: 'available', cabinetName: 'Cabinet 4' } },
            S1700: { state: { time: '17:00', status: 'available', cabinetName: 'Cabinet 4' } },
            S1730: { state: { time: '17:30', status: 'available', cabinetName: 'Cabinet 4' } }
          }
        }
      },

      // ─── SELECTED SLOT DETAIL ─────────────────────
      SlotDetail: {
        flow: 'y',
        gap: 'Z',
        padding: 'B',
        round: 'A',
        background: 'inkMid',
        border: '1px solid inkBorder',
        show: (el, s) => s.root.selectedSlot,

        DetailHeader: {
          flow: 'x', align: 'center space-between',
          DetailTitle: { text: '{{ slotDetails | polyglot }}', fontSize: 'A', fontWeight: '700', color: 'inkText' },
          CloseBtn: {
            text: '\u2715', fontSize: 'Z', fontWeight: '600', padding: 'Y Z', round: 'Y',
            background: 'inkSurface', border: '1px solid inkBorder', color: 'inkText', cursor: 'pointer',
            onClick: (e, el, s) => s.root.update({ selectedSlot: null })
          }
        },

        DetailGrid: {
          display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: 'Z',
          '@mobileL': { gridTemplateColumns: '1fr' },

          CabinetField: {
            flow: 'y', gap: 'X',
            FieldLabel: { text: '{{ cabinet | polyglot }}', fontSize: 'Y', fontWeight: '600', color: 'inkMuted', textTransform: 'uppercase', letterSpacing: 'X' },
            FieldValue: { text: (el, s) => s.root.selectedSlot?.cabinet || '-', fontSize: 'Z', color: 'inkText' }
          },
          TimeField: {
            flow: 'y', gap: 'X',
            FieldLabel: { text: '{{ time | polyglot }}', fontSize: 'Y', fontWeight: '600', color: 'inkMuted', textTransform: 'uppercase', letterSpacing: 'X' },
            FieldValue: { text: (el, s) => s.root.selectedSlot?.time || '-', fontSize: 'Z', color: 'inkText' }
          },
          StatusField: {
            flow: 'y', gap: 'X',
            FieldLabel: { text: '{{ status | polyglot }}', fontSize: 'Y', fontWeight: '600', color: 'inkMuted', textTransform: 'uppercase', letterSpacing: 'X' },
            FieldValue: {
              text: (el, s) => s.root.selectedSlot?.status || '-',
              fontSize: 'Z', fontWeight: '600',
              color: (el, s) => {
                const st = s.root.selectedSlot?.status
                if (st === 'occupied') return 'blue'
                if (st === 'cleaning') return 'amber'
                if (st === 'maintenance') return 'red'
                return 'teal'
              }
            }
          },
          DoctorField: {
            flow: 'y', gap: 'X',
            show: (el, s) => s.root.selectedSlot?.status === 'occupied',
            FieldLabel: { text: '{{ doctor | polyglot }}', fontSize: 'Y', fontWeight: '600', color: 'inkMuted', textTransform: 'uppercase', letterSpacing: 'X' },
            FieldValue: { text: (el, s) => s.root.selectedSlot?.doctor || '-', fontSize: 'Z', color: 'inkText' }
          },
          PatientField: {
            flow: 'y', gap: 'X',
            show: (el, s) => s.root.selectedSlot?.status === 'occupied',
            FieldLabel: { text: '{{ patient | polyglot }}', fontSize: 'Y', fontWeight: '600', color: 'inkMuted', textTransform: 'uppercase', letterSpacing: 'X' },
            FieldValue: { text: (el, s) => s.root.selectedSlot?.patient || '-', fontSize: 'Z', color: 'inkText' }
          },
          ProcedureField: {
            flow: 'y', gap: 'X',
            show: (el, s) => s.root.selectedSlot?.status === 'occupied',
            FieldLabel: { text: '{{ procedure | polyglot }}', fontSize: 'Y', fontWeight: '600', color: 'inkMuted', textTransform: 'uppercase', letterSpacing: 'X' },
            FieldValue: { text: (el, s) => s.root.selectedSlot?.procedure || '-', fontSize: 'Z', color: 'inkText' }
          }
        }
      }
    },
    MobileTabBar: {}
  }
}
